import { render, staticRenderFns } from "./UniEduSell.vue?vue&type=template&id=2362f869&scoped=true&"
import script from "./UniEduSell.vue?vue&type=script&lang=js&"
export * from "./UniEduSell.vue?vue&type=script&lang=js&"
import style0 from "./UniEduSell.vue?vue&type=style&index=0&id=2362f869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362f869",
  null
  
)

export default component.exports